<template>
    <transition name="fade">
      <div v-if="errorPopupVisible" class="fixed">
        <!-- Caja del mensaje de error -->
        <div class="bg-white popup">
          <div>
            <h2 class="title">Información</h2>
            <p class="message">{{ errorMessage }}</p>
            <div class="button-group">
              <button @click="closePopup" class="main_button">Entendido</button>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </template>
  
  <script setup>
  import { ref, watch, defineProps } from 'vue';
  
  // Define las props del componente para recibir el mensaje de error
  const props = defineProps({
    errorMessage: String,
  });
  
  const errorPopupVisible = ref(false);
  
  watch(() => props.errorMessage, (newVal) => {
    errorPopupVisible.value = !!newVal;
  });
  
  function closePopup(event) {
    errorPopupVisible.value = false;
    event.stopPropagation();
  }

  </script>
  
  <style scoped>
  /* Estilo de transición para suavizar la aparición/desaparición del popup */
  .fade-enter-active, .fade-leave-active {
    transition: opacity 0.3s ease;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
  }
  
  /* Fondo translúcido detrás del popup */
  .fixed {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1000;
  }
  
  /* Estilo de la caja que contiene el error */
  .bg-white {
    background-color: white;
    padding: 30px;
    border-radius: var(--radius-lg);
    box-shadow: var(--shadow-lg);
    width: 90%;
    max-width: 400px;
    text-align: center;
  }

  .title {
    margin-bottom: var(--spacing-md);
    color: var(--text-color-dark);
  }

  .message {
    color: var(--text-color-dark);
    margin-bottom: var(--spacing-lg);
    line-height: 1.6;
  }

  .button-group {
    margin-top: var(--spacing-lg);
  }

  @media (max-width: 768px) {
    .bg-white {
      width: 95%;
      padding: 20px;
    }
  }
  </style>
  